<template>
  <div class="modal_container" v-if="showModal">
    <van-popup
      v-model="showModal"
      style="border-radius: 16px"
      :close-on-click-overlay="false"
    >
      <div class="content_wrap">
        <div class="title">
          <p>{{ contentTitle }}</p>
        </div>
        <div class="content_area" @scroll="scrollEvent" ref="content">
          <div class="content">
            <p v-html="contentText"></p>
          </div>
        </div>
        <div
          class="sure_btn"
          :class="{ disbale: shadowFlag }"
          @click="sureEvent"
        >
          <div>确定</div>
          <span class="fake" v-if="shadowFlag"></span>
        </div>
        <div class="close" @click="closeEvent"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "modal-popup",
  components: {},
  props: {
    showNetErr: {
      type: Boolean,
      default: false,
    },
    contentTitle: {
      type: String,
      default: "标题",
    },
    contentText: {
      type: String,
      default: "内容",
    },
  },
  data() {
    return {
      showModal: false,
      shadowFlag: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    show() {
      this.showModal = false;
    },
    scrollEvent() {
      let scrollTop =
        this.$refs.content.pageYOffset ||
        this.$refs.content.scrollTop ||
        this.$refs.content.scrollTop; //滚动条Y轴上的滚动距离
      let scrollHeight = this.$refs.content.scrollHeight; //文档的总高度
      let windowHeight = this.$refs.content.clientHeight; //浏览器视口的高度
      if (scrollTop + windowHeight >= scrollHeight - 5) {
        this.shadowFlag = false;
      } else {
        this.shadowFlag = true;
      }
    },
    closeEvent() {
      if (this.shadowFlag) return;
      this.showModal = false;
      this.shadowFlag = true;
    },
    sureEvent() {
      if (this.shadowFlag) return;
      this.showModal = false;
      this.shadowFlag = true;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
.modal_container {
  .content_wrap {
    position: relative;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 315px;
    height: 459px;
    .close {
      position: absolute;
      width: 12px;
      height: 12px;
      top: 15px;
      right: 15px;
      z-index: 99999;
      // border: 1px solid red;
      background: url("../../assets/images/parent-course/close.png") no-repeat;
      background-size: contain;
    }
    .title {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      font-size: 16px;
      height: 22px;
      color: #000;
      line-height: 22px;
      margin-bottom: 15px;
    }
    .content_area {
      width: 315px;
      height: 459px;
      box-sizing: border-box;
      padding: 0 30px;
      overflow-y: scroll;
      .content {
        height: 330px;
        margin-top: 5px;
        font-size: 14px;
        color: #666;
        margin-bottom: 40px;
      }
    }
    .sure_btn {
      position: relative;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background: var(--btn-backgruond-color);
      &.disbale {
        background: #ccc;
      }
      color: #fff;
      font-size: 14px;
      .fake {
        position: relative;
        &::before {
          position: absolute;
          bottom: 50px;
          content: "";
          height: 75px;
          width: 315px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.33) 0%,
            #fff 100%
          );
        }
      }
      div {
        text-align: center;
      }
    }
  }
}
</style>
